export default __webpack_public_path__ + "static/media/pivotIPad.8ff37016.png";